import { ActiveFarmTypography } from '../../components/CustomStyles/StyledComponents';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

export default function SelectedFarm({ farmId, farmName }) {
    let navigate = useNavigate();
    
    const farmFID = useSelector(state => state?.adminFarm?.farmDetails?.friendlyFarmId);
  
    const gotoFarm = (farmId) => {
        navigate('/admin/farm/edit')
    }

    const NoFarm = "No farm selected";
    return (
        <ActiveFarmTypography style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>Active Farm :  </span>{farmId && farmName ?
                <Button variant="text" onClick={() => {gotoFarm(farmId)}}>
                    <ActiveFarmTypography style={{ textTransform: "none" }}>
                    {farmFID?`${farmFID} - `:''} {farmName}</ActiveFarmTypography>
                </Button> :
                NoFarm
            }
        </ActiveFarmTypography>
    );
}

SelectedFarm.propTypes = {
    farmId: PropTypes.string,
    farmName: PropTypes.string
};